import { CategoryGroupProductPage } from "@/features/category-group/pages/CategoryGroupProductPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/category-group/$id/category/$categoryID/products")({
	component: RouteComponent,
});

function RouteComponent() {
	const { id, categoryID } = Route.useParams();
	return <CategoryGroupProductPage id={id} categoryID={categoryID} />;
}
